module.exports = __webpack_public_path__ + "static/img/ic_close2.66c95090.png";